const memberStatusDictionnary = {
  'requested' : 'requested',
  'approved' : 'approved',
  'declined' : 'declined'
}
export default memberStatusDictionnary;
